import { AxiosInstance } from "axios";

export class LeadService {
  client: AxiosInstance;
  serviceName = 'lead_management';
  leads = `${this.serviceName}/leads/`;
  filters = `${this.serviceName}/filters/`;
  filter = `${this.serviceName}/filter`;
  filter_leads = `${this.serviceName}/filter/get-filtered-leads`;
  filter_leads_export = `${this.serviceName}/filter/export-csv`;
  export_uploaded_file = `${this.serviceName}/export-leads`;
  stats = `${this.serviceName}/stats`;

  constructor({ client }: { client: AxiosInstance }) {
    this.client = client;
  }

  uploadCSV(file: File, list_name: string) {
    const formData = new FormData();
    formData.append('attachment', file);
    formData.append('file_name', file.name);
    formData.append('list_name', list_name);
    formData.append('source_name', 'CSV Upload');
    return this.client.post(`${this.leads}`, formData);
  }

  getLeadLists(params: any = {}) {
    const queryParams = new URLSearchParams(params);
    return this.client.get(`${this.leads}?${queryParams.toString()}`);
  }

  addFilter(filter: { name: string, query: string, file_id: string }) {
    return this.client.post(`${this.filter}/`, filter);
  }

  getFilters(params: any = {}) {
    const queryParams = new URLSearchParams(params);
    return this.client.get(`${this.filters}?${queryParams.toString()}`);
  }

  updateFilter(payload: any = {}) {
    return this.client.patch(`${this.filters}${payload.id}/`, payload);
  }

  deleteFilter(filterId: string) {
    return this.client.delete(`${this.filters}${filterId}/`);
  }

  getFilteredLeads(params: any = {}) {
    return this.client.post(`${this.filter_leads}/`, params);
  }

  exportFilteredLeads(params: any = {}) {
    return this.client.post(`${this.filter_leads_export}/`, params);
  }

  exportUploadedFile(payload: { id: string }) {
    return this.client.post(`${this.export_uploaded_file}/`, payload);
  }

  getStats(params: any = {}) {
    return this.client.get(`${this.stats}/`, params);
  }

  deleteLeadList(leadListId: string) {
    return this.client.delete(`${this.leads}${leadListId}/`);
  }
}